import * as React from "react";
import { IBigCalendarResource } from "./big-calendar-component";
import { UserAvatar } from "../../../components/render-file/UserAvatar";

interface ICalendarStaffHeaderProps {
  resource: IBigCalendarResource;
}
export const CalendarStaffImageOnlyHeader: React.FunctionComponent<ICalendarStaffHeaderProps> = (
  props
) => {
  const resource = props.resource;
  return (
    <div className={"image-only-wraper"}>
      <div
        title={resource.resourceTitle}
        className="avatar-progress avatar-progress--xs position-relative cursor-pointer mr-2"
      >
        <svg>
          <circle r="12" cx="50%" cy="50%" className="default"></circle>
          <circle
            r="12"
            cx="50%"
            cy="50%"
            className="progress"
            stroke-dasharray="117"
            stroke-dashoffset="75"
          ></circle>
        </svg>

        {!resource.avatar && (
          <img
            src={require("../../../assets/images/user-noimage.png")}
            alt=""
            className="position-absolute left-0 right-0 top-0 bottom-0 m-auto rounded-circle"
          />
        )}
        {resource.avatar && (
          <UserAvatar
            id={resource?.resourceId}
            imageUrl={resource.avatar?.location}
            className="position-absolute left-0 right-0 top-0 bottom-0 m-auto rounded-circle"
            image={resource.avatar}
          ></UserAvatar>
        )}
      </div>
      <div>
        <div className="text-truncate font-xs text-gray-800 font-weight-semibold">
          {resource.resourceTitle}
        </div>
      </div>
    </div>
  );
};
